<script setup lang="ts">
import { watch } from 'vue';
import { RouterView, useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { ElMessage } from 'element-plus';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const router = useRouter();
const auth = useAuthStore();
const { isAuthenticated } = storeToRefs(auth);

// Mid-session expiry: when the session cookie expires the axios 401 interceptor
// clears the auth store (user → null) but does NOT navigate, so the user would
// otherwise sit on the page hitting repeated 401s until they manually switch
// routes. Here we react to the authenticated → unauthenticated transition and
// bounce to the internal login page.
//
// Guard against false positives / loops:
//  - Only fire on a real true → false transition (`was && !is`). The initial
//    unauthenticated state never had `was === true`, so app boot won't trigger.
//  - Skip login (`meta.guest`) and public pages — they don't require auth, and
//    redirecting away from them (or from login back to login) would be wrong.
watch(isAuthenticated, (is, was) => {
  if (!was || is || auth.loggingOut || auth.locallyLoggedOut) return;
  if (route.meta.guest || route.meta.public) return;
  void router.replace({ name: 'internal-login', query: { redirect: route.fullPath, iam_error: 'login_expired' } });
  ElMessage.warning('登录已过期,请重新登录');
});
</script>

<template>
  <RouterView />
</template>
